import { useAutoReplyProgressOrchestration } from '@/components/action-buttons/use-auto-reply-progress-orchestration';
import { useExportProgressOrchestration } from '@/components/action-buttons/use-export-progress-orchestration';
import {
    AiSelectedAnalysisProgress,
    ReviewsAutoReplyProgress,
    ReviewsExportProgress,
} from '@/context/reviews-page.context';
import { SocketIoEvents } from '@/events/socket-io.events';
import { Dispatch, SetStateAction } from 'react';

type UseActionButtonsControllerProgressArgs = {
    events: SocketIoEvents;
    isSocketConnected: boolean;
    aiAnalysisProgress: AiSelectedAnalysisProgress | null;
    exportProgress: ReviewsExportProgress | null;
    autoReplyProgress: ReviewsAutoReplyProgress | null;
    setExportProgress: Dispatch<SetStateAction<ReviewsExportProgress | null>>;
    setAutoReplyProgress: Dispatch<SetStateAction<ReviewsAutoReplyProgress | null>>;
};

export const useActionButtonsControllerProgress = ({
    events,
    isSocketConnected,
    aiAnalysisProgress,
    exportProgress,
    autoReplyProgress,
    setExportProgress,
    setAutoReplyProgress,
}: UseActionButtonsControllerProgressArgs) => {
    const { scheduleExportProgressCleanup } = useExportProgressOrchestration({
        events,
        isSocketConnected,
        setExportProgress,
    });
    const { scheduleAutoReplyProgressCleanup } = useAutoReplyProgressOrchestration({
        events,
        setAutoReplyProgress,
    });

    return {
        scheduleExportProgressCleanup,
        scheduleAutoReplyProgressCleanup,
        isAiAnalysisLoading: !!aiAnalysisProgress?.isRunning,
        isExportLoading: exportProgress !== null,
        isAutoReplyLoading: !!autoReplyProgress?.isRunning,
    };
};
